import { createAction, createAsyncAction } from 'typesafe-actions';
import { SiteFhq } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

export const fetchFhqs = createAsyncAction(
  'FETCH_FHQ_REQUEST',
  'FETCH_FHQ_SUCCESS',
  'FETCH_FHQ_FAILURE',
)<IdType, SiteFhq[], Error>();

export const updateFhqs = createAsyncAction(
  'UPDATE_FHQ_REQUEST',
  'UPDATE_FHQ_SUCCESS',
  'UPDATE_FHQ_FAILURE',
)<SiteFhq[], SiteFhq[], Error>();

export const setFhqsIsLoading = createAction('SET_FHQS_IS_LOADING')<undefined>();
